import { useSelector } from 'react-redux';

import { useEventTracking } from '@tsl-frontend/tsl-utilities';
import { Box, Button, Typography } from '@thirdspacelearning/library';

import { SessionIntroLO } from './index';

import { DATADOG_EVENT_NAMES } from '@consts';
import { useIntroLoCompleted } from '@hooks';
import { useAppDispatch } from '@store';
import { currClassroomURLSelector } from '@store/session';

const SessionStart = () => {
    const dispatch = useAppDispatch();

    const classroomURL = useSelector(currClassroomURLSelector);
    const hasClassroom = Boolean(classroomURL);

    const introLoCompleted = useIntroLoCompleted();

    const { sendUserTracking } = useEventTracking(dispatch);

    const startScheduledSession = () => {
        if (hasClassroom) {
            sendUserTracking(DATADOG_EVENT_NAMES.START_SESSION, {
                eventVersion: '1.0.0',
            });
            window.location.href = classroomURL;
        }
    };

    if (!introLoCompleted) {
        return <SessionIntroLO startIntroLO={startScheduledSession} />;
    }

    return (
        <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
            px={4}
            py={2}
        >
            <Box>
                <Typography
                    variant="h5"
                    fontWeight="bold"
                    data-testid="sessionStartingText"
                >
                    You can join your session now!
                </Typography>
            </Box>
            <Box flexShrink={0}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={startScheduledSession}
                    disabled={!hasClassroom}
                    data-testid="sessionStartingButton"
                >
                    Join session
                </Button>
            </Box>
        </Box>
    );
};

export default SessionStart;
